export default __webpack_public_path__ + "f0c41d3c84f4f01c728a7942da4281b9.svg";